import { doc, runTransaction, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

function pad(num, size = 4) {
  return String(num).padStart(size, '0');
}

function getYear(dateValue = new Date()) {
  const d = dateValue instanceof Date ? dateValue : new Date(dateValue);
  return d.getFullYear();
}

function getMonth(dateValue = new Date()) {
  const d = dateValue instanceof Date ? dateValue : new Date(dateValue);
  return String(d.getMonth() + 1).padStart(2, '0');
}

export async function generateInvoiceNumber({
  prefix = 'BH',
  mode = 'yearly',
  date = new Date(),
} = {}) {
  const year = getYear(date);
  const month = getMonth(date);

  const counterKey =
    mode === 'monthly'
      ? `invoice_${prefix}_${year}_${month}`
      : `invoice_${prefix}_${year}`;

  const counterRef = doc(db, 'counters', counterKey);

  const nextValue = await runTransaction(db, async (transaction) => {
    const snap = await transaction.get(counterRef);
    const currentValue = snap.exists() ? Number(snap.data()?.value || 0) : 0;
    const newValue = currentValue + 1;

    transaction.set(
      counterRef,
      {
        type: 'invoiceNumber',
        prefix,
        mode,
        year,
        month,
        value: newValue,
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );

    return newValue;
  });

  return mode === 'monthly'
    ? `${prefix}-${year}-${month}-${pad(nextValue)}`
    : `${prefix}-${year}-${pad(nextValue)}`;
}
